import { DashboardConfig } from '../../../../common/components/dashboards/types';
import { Languages } from '../../../../constants';
import { getNikkiLeaversDbPageConfigs } from './nikki-leavers-db-page-configs';

const dashboardId = 'global_hr_leavers';
export const NikkiLeaversDashboardConfig: DashboardConfig = {
  id: dashboardId,
  title: {
    [Languages.EN]: 'Global HR Leavers',
    [Languages.JA]: 'Global HR Leavers',
  },
  enabled: true,
  pages: getNikkiLeaversDbPageConfigs(dashboardId),
};
